import { render, staticRenderFns } from "./DetailOverview.vue?vue&type=template&id=1cf8466c&scoped=true"
import script from "./DetailOverview.vue?vue&type=script&lang=js"
export * from "./DetailOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf8466c",
  null
  
)

export default component.exports